import React, {useEffect, useMemo, useRef, useState} from 'react';
import Input from "../../UI/Input";
import Button from "../../UI/Button";
import RemoveIcon from "./RemoveIcon";
import commaSeparator, {formatToPersianAddComma, parseToEnRemoveComma} from "../../../utils/CommaSeparator";
import {ReactTabulator} from "react-tabulator";
import Loader from "../../Loader";
import {toast} from "react-toastify";
import TabulatorTableOptions from "../../../utils/TabulatorTableOptions";
import SelectOptionSearch from "../../UI/SelectOptionSearch";
import FloatingSection from "./FloatingSection";
import utilsFunction from "../../../utils/utilsFunction";
import ShowInfoSection from "./ShowInfoSection";
import {useNavigate} from "react-router-dom";
import objectDataHolder from "../../Hooks/ObjectDataHolder";
import Select from "react-select";
import {AddToTableIcon, Spinner} from "../../../Assets/svg";
import NewTabulator1 from "../../NewTabulator1/NewTabulator1";
import NewTabulator from "../../NewTabulator/NewTabulator";
import {isSelectedInArray} from "./SDFunctions";
import tableCalc from "../../../utils/tableCalc";
import {useDispatch, useSelector} from "react-redux";
import SelectMoienFormatter from "./TableColumnsFormatters/SelectMoienFormatter";
import DescriptionFormatter from "./TableColumnsFormatters/DescriptionFormatter";
import {submitDocumentFormAction} from "../../Store/SubmitDocumentForm";
import {deleteRowInSubmitForm, editCellInSubmitForm, getRowData, removeNeededValue} from "./functions";
import SelectTafsiliFormatter from "./TableColumnsFormatters/SelectTafsiliFormatter";
import {deleteRowHandlerInFactor} from "../../BuyFactorSadan/FactorNewDetails/functions";
import AddNewRow from "./TableColumnsFormatters/AddNewRow";
import {v4 as uuidv4} from 'uuid';


const MiddleSection = (props) => {
  const sendData = useSelector(s => s.submitDocumentFormReducer)
  const dispatch = useDispatch();


  const handleChangeTafsiliFormatter = async (e , selectedRowId, myKey) => {

    const value = e.target.value
    // find otherValues in Select option and Set To holder
    //find Table Row
    // console.log(selectedRowId)
    // console.log(sendData.tableData[0])
    // debugger

    let newTableData = [...sendData.tableData].map((v, index) => {
      const row = {...v}
      if (row.uniqId === selectedRowId) {
        row[myKey] = value
      }
      return row
    })




    //callBack(newTableData)
    const object1 = {type: "tafsil", value, rowId: selectedRowId, tableData: newTableData, dispatch}
    await getRowData(object1)
  }

  const handleChangeMoienFormatter = async (e , selectedRowId , myKey) => {

    const value = e.target.value

    // find otherValues in Select option and Set To holder
    const filteredData = sendData.documentPageData.accounts.filter(row => row.value === value)[0]
    //find Table Row
    const myMap = (v, index) => {
      let row = {...v}
      if (row.uniqId === selectedRowId) {
        row['holder'] = filteredData?.hasSubAccount ? JSON.stringify(filteredData) : undefined
      }
      return row
    }


    let newTableData = [...sendData.tableData].map(myMap)

    const callBack = (newTableData) => {
      editCellInSubmitForm({
        tableData: newTableData, selectedRowId, myKey: myKey, value, dispatch
      });
    }


    callBack(newTableData)
    filteredData.hasSubAccount === false && getRowData({
      type: "moien", value, rowId: selectedRowId, tableData: newTableData, dispatch
    })

  }


  const myTableColumns = [
    {
      visible: false,
      title: "myId", field: "uniqId",

      style: {
        minWidth: 40,
        maxWidth: 40,
        width: 40,
        textAlign: "center",
      }
    },
    {
      title: "ردیف", field: "indexRow",
      style: {
        minWidth: 40,
        maxWidth: 40,
        width: 40,
        textAlign: "center",
      }
    },
    {
      title: "عنوان حساب", field: "accountCode",
      formatter: (cell) => {
        return <SelectMoienFormatter
          handleChange={handleChangeMoienFormatter}
          key={uuidv4()} myKey={"level3Code"} cell={cell}/>
      },
      cellEdited :()=>{

      },
      style: {
        // minWidth: 300,
        // maxWidth: 300,
        width: '100%',
        textAlign: "center",
      },
    },

    {
      title: "holder", field: "holder", visible: false,
      style: {
        // minWidth: 300,
        // maxWidth: 300,
        width: '20',
        height: 20,
        overflow: "hidden",
      },
    },
    {
      title: "تفصیلی", field: "tafsili",

      formatter: (cell) => {
        return <SelectTafsiliFormatter
          key={uuidv4()}
          handleChange={handleChangeTafsiliFormatter}
          myKey={"tafsili"} cell={cell}
        />
      },
      style: {
        // minWidth: 300,
        // maxWidth: 300,
        width: '100%',
        textAlign: "center",
      },
    },
    {title: "مقدار کد حساب", field: "accountCode", visible: false},
    {title: "عنوان حساب", field: "accountTitle", visible: false},
    {
      title: "توضیحات", field: "description",
      editor: "text",
      cellEdited: (e, cell) => {


        // debugger
        // const cellId = cell.getData().id
        // const tableData = sendData.tableData.map(row => {
        //   const myRow = {...row}
        //   if (myRow.id === cellId) {
        //     myRow.description = e.target.value;
        //   }
        //   return myRow
        // })
        //
        // dispatch(submitDocumentFormAction.fillInput({tableData}))

        editCellInSubmitForm({
          tableData: sendData.tableData,
          selectedRowId: cell.getData().uniqId,
          myKey: "description",
          value: e.target.value,
          dispatch
        })


      },
      style: {
        minWidth: 300,
        maxWidth: 300,
        width: 300,
        textAlign: "right",
        direction:'rtl',
      }

    },

    // {title: "t", field: "floatingAccount"},
    // {title: "t", field: "floatingAccountCode"},
    // {title: "t", field: "floatingAccountTitle"},
    {
      title: "بدهکار", field: "bed",
      bottomCalc: "sum",
      style: {
        minWidth: 140,
        maxWidth: 140,
        width: 140,
        textAlign: "center"
      },
      editor: "number",
      formatter: tableCalc.separateNumbers,
      cellEdited: (e, cell) => {
        const parsedValue = parseToEnRemoveComma(e.target.value)
        e.target.value = parsedValue.replace(/[^0-9.]/g, '');

        const t = {
          tableData: sendData.tableData,
          selectedRowId: cell.getData().uniqId,
          myKey: "bed",
          value: e.target.value,
          dispatch,
          needToDelete: {
            removeKey: "bes"
          }
        }


        // اول به محض اینکه اینجا تایپ کرد  باید بستانکار رو حذف کنم.
        // حالا باید  مقداری که وارد کرده رو ست کنم.


        // removeNeededValue({
        //   tableData: sendData.tableData,
        //   selectedRowId: cell.getData().uniqId,
        //   dispatch,
        //   removeValue: "bes"
        // })

        editCellInSubmitForm(t)
      },


    },
    {
      title: "بستانکار",
      field: "bes",
      bottomCalc: "sum",
      style: {
        minWidth: 140,
        maxWidth: 140,
        width: 140,
        textAlign: "center"
      },
      editor: "number",
      formatter: tableCalc.separateNumbers,

      cellEdited: (e, cell) => {

        const parsedValue = parseToEnRemoveComma(e.target.value)
        e.target.value = parsedValue.replace(/[^0-9.]/g, '');

        const t = {
          tableData: sendData.tableData,
          selectedRowId: cell.getData().uniqId,
          myKey: "bes",
          value: e.target.value,
          dispatch,
          needToDelete: {
            removeKey: "bed"
          }
        }


        // اول به محض اینکه اینجا تایپ کرد  باید بستانکار رو حذف کنم.
        // حالا باید  مقداری که وارد کرده رو ست کنم.


        // removeNeededValue({
        //   tableData: sendData.tableData,
        //   selectedRowId: cell.getData().uniqId,
        //   dispatch,
        //   removeValue: "bed"
        // })

        editCellInSubmitForm(t)
      },
    },
    {visible: false, title: "", field: "hasSubAccount"},
    {visible: false, title: "level1 Code", field: "level1Code"},
    {visible: false, title: "level1 Name", field: "level1Name"},
    {visible: false, title: "level2 Code", field: "level2Code"},
    {visible: false, title: "level2 Name", field: "level2Name"},
    {visible: false, title: "level3 Code", field: "level3Code"},
    {visible: false, title: "level3 Name", field: "level3Name"},
    {visible: false, title: "level4 Code", field: "level4Code"},
    {visible: false, title: "level4 Name", field: "level4Name"},
    {visible: false, title: "level4 FloatingCode", field: "level4FloatingCode"},
    {
      title: "حذف", formatter: "buttonCross",
      style: {
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        textAlign: "center"
      },
      cellClick: function (e, cell) {
        //console.log("حذف حذف حذف");

        const t = {
          tableData: sendData.tableData,
          selectedRowId: cell.getData().uniqId,
          dispatch,
        }

        deleteRowInSubmitForm(t)
      }

    },
    {
      title: "", formatter: (cell) => {

        return <AddNewRow cell={cell}/>
      },
      style: {
        minWidth: 100,
        maxWidth: 100,
        width: 100,
        textAlign: "center"
      },
    },
  ]


  // let {
  //   accountTitle,
  //   value,
  //   accountCode,
  //   accountText,
  //   whichKey,
  //   description,
  //   bed,
  //   bes,
  //   floatingAccountList,
  //   floatingAccountCode,
  //   floatingAccountTitle,
  // } = props?.middleData;
  // console.log("value:", value)
  // value = value.toString()

  // const {accountTitles, accountCodes} = props.initialData;


  const [whichViewToSearch, setWhichViewToSearch] = useState("accountTitle")
  const changeSearchTypeHandler = (event) => {
    const value = event.target.value;
    // const form = formRef.current;
    // form.querySelector('.coding__search__button__selected').classList.remove("coding__search__button__selected")
    // event.target.previousSibling.firstElementChild.classList.toggle("coding__search__button__selected")
    setWhichViewToSearch(value);

    props.middleDataHandler("type", value)

  }





  return (<div className={'mt-3'}>

    <hr/>
    <div style={{height: '350px', overflowY: 'scroll', width: '100%',}}
         className={"d-flex justify-content-around flex-row"}
    >

      <>
        <div style={{width: '100%'}} className={"setCenterAlignInMiddleSection"}>
          {/*<NewTabulator
              columns={props.tableColumns}
              data={props.tableData}
              style={{height: "35vh", overflow: 'scroll'}}
              className={"header__color__F1F1F1"}
            />*/}
          <NewTabulator
            columns={myTableColumns}
            data={sendData.tableData}
            className={"header__color__F1F1F1"}


            // events={{rowClick: rowClickHandler}}
          />
        </div>

      </>

    </div>

    <>
    </>
  </div>);
};

export default MiddleSection;
